import React from 'react';
import { AlertCircle, CheckCircle, Info } from 'lucide-react';

export interface CustomAlertProps {
  isOpen: boolean;
  type: 'success' | 'error' | 'info';
  title: string;
  message: string;
  onClose: () => void;
}

export const CustomAlert: React.FC<CustomAlertProps> = ({ isOpen, type, title, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm transition-opacity">
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-xl p-6 w-full max-w-sm animate-in fade-in zoom-in duration-200">
        <h2 className={`text-lg font-bold mb-3 flex items-center gap-2 ${type === 'error' ? 'text-red-500' : type === 'success' ? 'text-emerald-500' : 'text-blue-500'}`}>
          {type === 'error' && <AlertCircle className="w-5 h-5" />}
          {type === 'success' && <CheckCircle className="w-5 h-5" />}
          {type === 'info' && <Info className="w-5 h-5" />}
          {title}
        </h2>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-6">
          {message}
        </p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className={`px-4 py-2 text-sm font-semibold text-white rounded-xl ${
              type === 'error' ? 'bg-red-600 hover:bg-red-700' :
              type === 'success' ? 'bg-emerald-600 hover:bg-emerald-700' :
              'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
